<template>
  <header>
    <div class="fixed">
      <div class="header">
        <div class="toggle" @click="menuToggle">
          {{ $t('header.menuToggle') }}
        </div>
        <ul class="breadcrumb">
          <li>
            <div class="item" @click="goHome('/')">
              {{ $t('header.home') }}
            </div>
          </li>
          <li>
            <div class="item">
              {{currentClubName}}
            </div>
          </li>
        </ul>
      </div>
      <div class="body">
        <h1 class="bi" @click="goHome('/')">
          {{ $t('header.voicecaddie') }}
        </h1>
      </div>
      <div class="footer">
        <div class="lang-switch">
          <button type="button" :class="{ active: $i18n.locale === 'ko' }" @click="changeLocale('ko')">
            KO
          </button>
          <button type="button" :class="{ active: $i18n.locale === 'en' }" @click="changeLocale('en')">
            EN
          </button>
        </div>
        <!-- 활성(Class) : active -->
        <div class="alarm" :class="alarmList.length > 0" @click="moveMenu('/AL001')">
          <div class="item">
            {{ $t('header.alarm') }}
          </div>
        </div>
        <h2 class="club">
          <!-- 이미지(Style) : 경로 -->
          <div class="item" v-if="this.clubInfo.club_logo !== null && this.clubInfo.club_logo" :style="{'background-image': 'url(' + clubInfo.club_logo + ')'}">
            {{ $t('header.clubBi') }}
          </div>
        </h2>
      </div>
    </div>
  </header>
</template>
<script>
import { mapActions } from 'vuex'
import { clubInfoService, settingService, userService } from '../../router'
import { setLocale } from '../../i18n'
export default {
  name: 'headerLayout',
  data () {
    return {
      userInfo: {},
      clubInfo: {
        club_logo: null
      },
      currentClubName: '',
      alarmList: []
    }
  },
  created: function () {
    if (document.querySelector('body') !== null) document.querySelector('body').classList.add('inactiveBi')
  },
  mounted: async function () {
    const getUserInfo = userService.getAll()
    const getAllClubInfoList = clubInfoService.getClubInfoList()
    const getDefaultClubInfoList = settingService.getClubInfoList(1, 1, 'active', '', '', '', 'club_name', 'asc')
    Promise.all([getUserInfo, getAllClubInfoList, getDefaultClubInfoList]).then(([userInfo, allClubList, defaultClub]) => {
      this.userInfo = userInfo.data
      if (this.userInfo.userRole === 'ClubManager') {
        settingService.getClubInfoDetail(this.userInfo.ccode).then(response => {
          this.clubInfo = response.data.clubInfo
          if (this.clubInfo.club_logo !== null && this.clubInfo.club_logo) {
            document.querySelector('body').classList.remove('inactiveBi')
          }
        }).catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
      }

      this.clubInfoList = allClubList.data.clubInfoList
      defaultClub = defaultClub.data.clubInfoList
      if (this.userInfo.userRole === 'ClubManager') {
        this.currentClubCode = this.userInfo.ccode
      } else if (!this.$route.query.ccode) {
        this.currentClubCode = localStorage.getItem('currentCcode') || defaultClub[0].ccode
      } else {
        this.currentClubCode = this.$route.query.ccode
      }
      this.currentClubInfo = this.clubInfoList.find(it => it.ccode === this.currentClubCode)
      this.currentClubName = this.currentClubInfo === undefined ? '' : this.currentClubInfo.club_name
      this.setClubs(allClubList.data.clubInfoList)
      this.selectClub(this.currentClubInfo)
    }).catch(error => {
      console.log('aplManagerService.getManagementUserClubName.err.===>', error)
    })
    this.setData()
  },
  methods: {
    changeLocale: function (locale) {
      setLocale(locale)
    },
    setData: function () {
      userService.getAlarm().then(response => {
        this.alarmList = response.data
      })
    },
    goHome: function () {
      const userRole = this.$store.state.users.userInfo.userRole
      if (this.$route.path === '/HO001' && userRole !== 'ClubManager') return
      if (this.$route.path === '/HO101' && userRole === 'ClubManager') return
      this.moveMenu('/')
    },
    ...mapActions('clubs', {
      setClubs: 'setClubs',
      selectClub: 'setSelectedClub'
    })
  }
}
</script>
<style scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
  vertical-align: middle;
}
.lang-switch button {
  min-width: 34px;
  padding: 3px 6px;
  border: 1px solid #d0d0d0;
  background: #fff;
  color: #888;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
}
.lang-switch button:first-child {
  border-radius: 3px 0 0 3px;
  border-right: none;
}
.lang-switch button:last-child {
  border-radius: 0 3px 3px 0;
}
.lang-switch button.active {
  background: #333;
  border-color: #333;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue